<template>
  <div id="activity">
    <Header :title="title">
      <template slot="right">
        <div class="mybarRight" v-on:click="toSearch">
          <span class="iconfont icon-sousuo f12 color_999" />
        </div>
      </template>
    </Header>

    <main class="MainCon bottom0 activityBg" id="MainCon">

      <p class="tc mt10"><span class="activityTitleBg">店铺好券</span></p>
      <div class="ml7 mr7 mt10 mb20">
        <div class="indexMenuBoxList flexBetween">
          <div class="flexBox-cell-48 mb5" v-on:click="toUrl(item.mobile_url)" v-for="(item,index) in couponList"
               :key="index">
            <div class="couponListBrand">
              <div class="myimg"><img v-bind:src="item.bg_image" /></div>
              <div class="couponListBrandBox">
                <p class="tc"><img v-bind:src="item.logo" /></p>
                <p class="color_fff tc f8 mt3">{{ item.shop_name }}</p>
              </div>
            </div>
            <div class="couponListBlock pb5">
              <div class="ml7 mr7">
                <p class="f8 color_999 lh24"><em class="color_eleven">￥<em
                    class="f10">{{ item.coupon_amount }}</em></em>&nbsp;{{ item.describe }}</p>
                <div class="couponListBlockBtn">立即领券&nbsp;<em class="iconfont icon-kuaizhuang"></em></div>
              </div>
            </div>
          </div>
        </div>
        <p class="tc mt12 mb20" v-show="isMore"><span class="brand-loadingBtn" v-on:click="loadingMore()">点击加载更多</span>
        </p>
      </div>
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header';
import {appService} from "@/services/app";
import {isMobile} from "@/libs/utils";

export default {
  components: {
    Header
  },
  data() {
    return {
      title: '品牌店铺',
      couponList: [],
      btnFlag: false,
      isMore: true,
      currentPage: 1,
    };
  },
  created() {
    if (!isMobile()) {
      window.location.href = window.location.origin + '/activity';
    }
    this.fetchLargeCouponList();
  },
  methods: {
    fetchLargeCouponList: function () {
      let self = this;
      appService.fetchLargeCouponList({pageNum: self.currentPage}).then((res) => {
        let {code, data} = res;
        if (code === 1) {
          if (self.currentPage < data.page_count) {
            self.isMore = true;
          } else {
            self.isMore = false;
          }
          if (data.list.length > 0) {
            for (let i = 0; i < data.list.length; i++) {
              self.couponList.push(data.list[i]);
            }
          }
        }
      });
    },
    loadingMore: function () {
      let self = this;
      ++self.currentPage;
      self.fetchLargeCouponList();
    },
    toUrl: function (url) {
      if (url) window.location.href = url;
    },
    toSearch: function () {
      this.$router.push({name: 'search'});
    },
  }
}
</script>

<style scoped>

</style>
